import { ButtonSize } from "@galaxy-io/dls/buttons/Button";
import Flex, { AlignItems, FlexDirection } from "@galaxy-io/dls/layout/Flex";
import Text, { TextSize, TextVariant, TextWeight } from "@galaxy-io/dls/text/Text";
import type { ReactNode } from "react";

const CONTROL_HEIGHT: Record<ButtonSize, number> = {
  [ButtonSize.X_SMALL]: 20,
  [ButtonSize.SMALL]: 24,
  [ButtonSize.MEDIUM]: 32,
  [ButtonSize.LARGE]: 36,
  [ButtonSize.X_LARGE]: 40,
};
export function BaseHeader({
  title,
  description,
  actions,
  leading,
  id,
  level = 1,
  titleSize = level === 1 ? TextSize.HEADING_MD : TextSize.HEADING_SM,
  titleWeight = TextWeight.MEDIUM,
  actionSize = ButtonSize.MEDIUM,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  leading?: ReactNode;
  id?: string;
  level?: number;
  titleSize?: TextSize;
  titleWeight?: TextWeight;
  actionSize?: ButtonSize;
}) {
  return (
    <Flex
      alignItems={AlignItems.CENTER}
      gap={12}
      minHeight={CONTROL_HEIGHT[actionSize]}
      minWidth={0}
      fillWidth
    >
      {leading}
      <Flex direction={FlexDirection.COLUMN} gap={2} grow={1} minWidth={0}>
        <Text
          as={level === 1 ? "h1" : level === 2 ? "h2" : "h3"}
          id={id}
          size={titleSize}
          weight={titleWeight}
          lineClamp={1}
          shouldTooltipOnOverflow
        >
          {title}
        </Text>
        {description && <Text variant={TextVariant.SECONDARY}>{description}</Text>}
      </Flex>
      {actions && (
        <Flex alignItems={AlignItems.CENTER} gap={8} shrink={0}>
          {actions}
        </Flex>
      )}
    </Flex>
  );
}
